import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.dataStudio.fields.id'),
  },
  {
    name: 'name',
    label: i18n('entities.dataStudio.fields.name'),
  },
  {
    name: 'link',
    label: i18n('entities.dataStudio.fields.link'),
  },
  {
    name: 'permissionRoles',
    label: i18n(
      'entities.dataStudio.fields.permissionRoles',
    ),
  },
  {
    name: 'createdAt',
    label: i18n('entities.dataStudio.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.dataStudio.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
